<template>
  <div class="max">
    <div class="left_box">
      <RegisterAndLoginBackImage :imgPath="require('../../../assets/newImage/bg_2.jpg')" />
    </div>
    <div class="right_box">
      <router-view></router-view>
      <footerInfo style="position:absolute;bottom:0;left:0;right: 0;" />
    </div>
  </div>
</template>

<script>
import RegisterAndLoginBackImage from './components/RegisterAndLoginBackImage.vue';
import footerInfo from '../frame/footerInfo.vue';
export default {
  data () {
    return {

    }
  },
  components: {
    RegisterAndLoginBackImage,
    footerInfo
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.max {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 500px 1fr;

  .right_box {
    padding: 20px;
    position: relative;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/newPages/login/register.vue